<template>
  <div class="dete-select-nav">
    <el-select :value="selectType" @input="changeType" class="info-date-select" >
      <el-option :label="item.key" :value="item" v-for="item in fee_desc" :key="item.key">
        <span style="float: left">{{ item.key }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
      </el-option>
    </el-select>

    <div v-if="showSelectSed" class="divider"></div>

    <el-select :value="selectDay" @input="changeDays" v-if="showSelectSed" class="info-date-select" >
      <el-option :value="item" v-for="item in daysArr" :key="item">{{item}}</el-option>
    </el-select>
  </div>
</template>

<script>

export default {
  props: {
    fee_desc: {
      type: Array,
      default() {
        return [];
      },
    },
    selectDefaultDay: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selectType: '',
      selectDay: 0,
      daysArr: [],
      price: 0,
      showSelectSed: false,
    };
  },
  watch: {
    selectDefaultDay() {
      this.fee_desc.forEach((item) => {
        if (this.selectDefaultDay >= item.min && this.selectDefaultDay <= item.max) {
          this.selectType = item.key;

          this.changeType(item, false);

          if (this.showSelectSed) {
            this.changeDays(this.selectDefaultDay, false);
          }
        }
      });
    },
  },
  methods: {
    changeDays(e, run = true) {
      this.selectDay = e;
      this.price = (e - this.defaultDay) * this.singlePrice + this.defaultPrice;

      if (run) {
        this.$emit('change', { price: this.price, days: this.selectDay });
      } else {
        this.$emit('price', this.price);
      }
    },
    changeType(item, run = true) {

      if (this.selectType === item.key && run) {
        return;
      }
      this.selectType = item.key;

      let day = 0;

      if (item.max === this.fee_desc[this.fee_desc.length - 1].max && item.step) {
        this.showSelectSed = true;

        this.daysArr = Array.from({ length: item.max - item.min + 1 }, (v, i) => i + item.min);
        this.selectDay = item.min;
        this.defaultDay = this.fee_desc[this.fee_desc.length - 2].max;

        this.defaultPrice = this.fee_desc[this.fee_desc.length - 2].fee / 100;
        this.singlePrice = item.fee / 100;
        day = item.min;
      } else {
        this.showSelectSed = false;
        this.defaultPrice = item.fee / 100;
        this.singlePrice = 0;
        day = item.max;
      }

      if (run) {
        this.$emit('change', { price: (this.defaultPrice + this.singlePrice), days: day });
      } else {
        this.$emit('price', this.price);
      }
    },
  },
  mounted() {
    let bz = true;
    this.fee_desc.forEach((item) => {
      if (!item.step && bz) {
        this.changeType(item);
        bz = false;
      }
    });
  },
};
</script>

<style lang="less" >
.dete-select-nav {
  border-radius: 4px;
  border: solid 1px #dddddd;
  height: auto;
  overflow: hidden;
  .info-date-select {
    width: 100%;
    .el-input {
      .el-input__inner {
        border: none;
        height: 39.5px;
      }
    }
  }
  .divider {
    width: calc(~"100% - 10px");
    margin-left: 10px;
    height: 1px;
    background:#e9e9e9;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/businessInsurance/popupBox/select.vue